var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticStyle: { "margin-bottom": "40px", "text-align": "center" },
          attrs: { "align-h": "center" }
        },
        [
          _c("b-col", { attrs: { cols: "12", md: "5" } }, [
            _c("h4", { staticClass: "font-weight-bold mb-4" }, [
              _vm._v("Select Amount")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "fire mb-2" }, [
              _vm._v("🔥 Limited time. Pay what you can afford")
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.membershipText))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "range-container" },
              [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center mb-3" },
                  [
                    _c("span", { staticClass: "price-approx" }, [
                      _vm._v(_vm._s(_vm.approxText))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "price-text mb-1", class: _vm.textRule },
                      [_vm._v("$" + _vm._s(_vm.rangeVal))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "price-per-month" }, [
                      _vm._v("/month")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-inline-block w-100 mb-5 px-3" },
                  [
                    _c("vue-slider", {
                      attrs: {
                        tooltip: "none",
                        min: _vm.min,
                        max: _vm.max,
                        "dot-size": 32,
                        "dot-style": { background: "#224181" },
                        "rail-style": { backgroundColor: "#AAAAAA" },
                        contained: true,
                        marks: _vm.marks
                      },
                      on: { change: _vm.selectPrice },
                      scopedSlots: _vm._u(
                        [
                          _vm.recurring === true
                            ? {
                                key: "mark",
                                fn: function(ref) {
                                  var pos = ref.pos
                                  var label = ref.label
                                  return [
                                    label === _vm.lowestPrice
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-mark-start" },
                                          [
                                            _vm._v(
                                              "\n                $" +
                                                _vm._s(label) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : label === _vm.defaultPrice
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "custom-mark",
                                            style: { left: pos + "%" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "arrow",
                                              attrs: {
                                                icon: ["fas", "caret-up"],
                                                size: "3x"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "recommend-text" },
                                              [_vm._v("Recommended Price")]
                                            )
                                          ],
                                          1
                                        )
                                      : label === _vm.max
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-mark-end" },
                                          [
                                            _vm._v(
                                              "\n                $" +
                                                _vm._s(label) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            : !_vm.recurring
                            ? {
                                key: "mark",
                                fn: function(ref) {
                                  var pos = ref.pos
                                  var label = ref.label
                                  return [
                                    label === _vm.lowestPrice
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-mark-start" },
                                          [
                                            _vm._v(
                                              "\n                $" +
                                                _vm._s(label) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    label === _vm.defaultPrice
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "custom-mark",
                                            style: { left: pos + "%" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "arrow",
                                              attrs: {
                                                icon: ["fas", "caret-up"],
                                                size: "3x"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "recommend-text" },
                                              [_vm._v("Recommended Price")]
                                            )
                                          ],
                                          1
                                        )
                                      : label === _vm.max
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-mark-end" },
                                          [
                                            _vm._v(
                                              "\n                $" +
                                                _vm._s(label) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            : null
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.rangeVal,
                        callback: function($$v) {
                          _vm.rangeVal = $$v
                        },
                        expression: "rangeVal"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "info-text d-inline-block w-90 mt-2",
                    class: _vm.infoTextColor
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.infoTextRule) + "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block mb-3 mt-5",
                      on: { click: _vm.pay }
                    },
                    [_vm._v("Change Amount")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-center d-flex flex-column align-items-center"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "margin-bottom": "-3px"
                          }
                        },
                        [_vm._v("*All prices exclusive of Stripe fees")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "*1% additional fee will be added for countries outside US"
                        )
                      ])
                    ]
                  )
                ]
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c67d2bb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c67d2bb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChangeSubscription.vue
// module id = null
// module chunks = 